export default __webpack_public_path__ + "static/media/dog2.78649054.JPG";